import { render, staticRenderFns } from "./device-information.vue?vue&type=template&id=5b22160f"
import script from "./device-information.vue?vue&type=script&lang=js"
export * from "./device-information.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports